const KEYS = {
    CITY: 'City',
    ID_CLASS: 'Class',
    COUNTRY_SHORT: 'CountryShort',
    DATE_OF_BIRTH: 'DateOfBirth4',
    DOCUMENT_TYPE: 'DocType',
    ID_EXPIRATION_DATE: 'ExpirationDate4',
    EYES: 'Eyes',
    FATHERS_NAME: 'FatherName',
    HAIR: 'Hair',
    HEIGHT: 'Height',
    WEIGHT: 'Weight',
    FACE_IMAGE: 'face_image',
    FACE_MATCH_SCORE: 'face_match_score',
    ID_NUMBER: 'Id',
    ID_COUNTRY: 'IdCountry',
    ISSUED_DATE: 'IssueDate4',
    FIRST_NAME: 'NameFirst',
    LAST_NAME: 'NameLast',
    MIDDLE_NAME: 'NameMiddle',
    SEX: 'Sex',
    STATE: 'State',
    ZIP: 'Zip',
    LICENSE: 'license',
    ID_TYPE: 'CardType',
    ISSUER_STATE: 'DocumentDetectedName',
    DOCUMENT_CONFIDENCE_RATING: 'DocumentVerificationConfidenceRating',
    IS_BARCODE_READ: 'IsBarcodeRead',
    IS_OCR_READ: 'IsOcrRead',
    ID_PARSING_RESULT: 'Result',
    ADDRESS: 'Address',
    ID_BACK: 'id_back',
    ID_FRONT: 'id_front',
    SELFIE_IMAGE: 'selfie_image',
    SIGNATURE_IMAGE: 'signature_image',
    LIVENESS_RESULT: 'liveness_result',
    LIVENESS_ERROR: 'liveness_error',
    LIVENESS_ERROR_CODE: 'liveness_error_code',
    METHOD: 'Method',
};

const KEY_TO_TITLE_MAP = {
    [KEYS.DOCUMENT_CONFIDENCE_RATING]: 'Confidence Rating',
    [KEYS.ID_PARSING_RESULT]: 'ID Parse State',
    [KEYS.METHOD]: 'Method',

    [KEYS.IS_BARCODE_READ]: 'Is Barcode Read',
    [KEYS.IS_OCR_READ]: 'Is OCR Read',
    [KEYS.LICENSE]: 'License',

    [KEYS.LIVENESS_RESULT]: 'Liveness Result',
    [KEYS.LIVENESS_ERROR]: 'Liveness Error',
    [KEYS.LIVENESS_ERROR_CODE]: 'Liveness Error Code',

    [KEYS.SELFIE_IMAGE]: 'Selfie Image',
    [KEYS.FACE_MATCH_SCORE]: 'Face Match Score',
    [KEYS.SIGNATURE_IMAGE]: 'Signature Image',

    [KEYS.ID_FRONT]: 'ID Front Image',
    [KEYS.ID_BACK]: 'ID Back Image',
    [KEYS.ID_TYPE]: 'ID Type',

    [KEYS.ID_NUMBER]: 'ID Number',
    [KEYS.ID_EXPIRATION_DATE]: 'ID Expiration Date',
    [KEYS.ISSUED_DATE]: 'ID Issued Date',

    [KEYS.ID_CLASS]: 'ID Class',
    [KEYS.ID_NUMBER]: 'ID Number',
    [KEYS.DOCUMENT_TYPE]: 'Document Type',

    [KEYS.ISSUER_STATE]: 'Issuer State',
    [KEYS.DATE_OF_BIRTH]: 'Date of Birth',
    [KEYS.COUNTRY_SHORT]: 'Country',

    [KEYS.FIRST_NAME]: 'First Name',
    [KEYS.MIDDLE_NAME]: 'Middle Name',
    [KEYS.LAST_NAME]: 'Last Name',

    [KEYS.FATHERS_NAME]: "Father's Name",
    [KEYS.HEIGHT]: 'Height',
    [KEYS.WEIGHT]: 'Weight',

    [KEYS.ADDRESS]: 'Address',
    [KEYS.CITY]: 'City',
    [KEYS.STATE]: 'State',

    [KEYS.ZIP]: 'Zip',
    [KEYS.EYES]: 'Eyes',
    [KEYS.HAIR]: 'Hair',

    [KEYS.SEX]: 'Sex',
    [KEYS.FACE_IMAGE]: 'Face Image',
};

// Keeping this short for now, can be expanded when needed.
const TITLES = {
    CONFIDENCE_RATING: KEY_TO_TITLE_MAP[KEYS.DOCUMENT_CONFIDENCE_RATING],
    LIVENESS_RESULT: KEY_TO_TITLE_MAP[KEYS.LIVENESS_RESULT],
    LIVENESS_ERROR: KEY_TO_TITLE_MAP[KEYS.LIVENESS_ERROR],
    ID_PARSING_RESULT: KEY_TO_TITLE_MAP[KEYS.ID_PARSING_RESULT],
};

export const MEDALLION_ID_RESPONSE = {
    GOVT_ID: {
        KEYS,
        KEY_TO_TITLE_MAP,
        TITLES,
    },
};

export const INVALID_SSN_MESSAGE =
    "We could not verify the SSN. Please review the SSN and the user's PII and make sure it is accurate.";

export const USER_DECEASED_BANNER = {
    LEARN_MORE_PATH: 'https://info.authenticate.com/authoritative-database-search-usa',
    CONTACT_US_PATH: 'https://info.authenticate.com/kb-tickets/new',
};

export const GOVT_ID_API_IMAGE_KEY_MAP = {
    ID_FRONT: 'id_front',
    ID_BACK: 'id_back',
    SELFIE: 'selfie_image',
    SIGNATURE: 'signature_image',
    FACE: 'face_image',
};

export const GOVT_ID_API_WATERMARK_IMAGE_KEY_MAP = {
    ID_FRONT: 'idFront',
    ID_BACK: 'idBack',
    SELFIE: 'selfie',
    SIGNATURE: 'signature',
    FACE: 'face',
};

export const GLOBAL_CHECK_TOOLTIP = {
    GWC: 'Check will be disabled if already run before or the ID Proof is not valid.',
    SOC: 'An Sex offender Check is already running. You can run again once the previous check is completed.',
};
